/* eslint-disable no-console -- logger */
// import {
//   EAnalyticsEvent,
//   EAnalyticsEventAction,
//   EAnalyticsEventCategory,
// } from "@c4c-web/core/constants";
import type { IOnLoadProps, IOnMapCenterChangedProps } from "../types";
// import { EAnalyticsEventLabel, EAnalyticsScreenName } from "../constants";
// import { getDefaultAddressAnalyticsParams } from "./analytics.utils";

export const onMapLoad = ({
  map,
  searchBarRef,
  options,
  setIsSelected,
  setCoordinates,
  setUpdatedLocation,
  setFormattedAddress,
  checkAreaSupport,
  setMapInstance,
  // sendEvent,
}: IOnLoadProps): void => {
  const input = searchBarRef?.current;
  if (input) {
    const autocomplete = new window.google.maps.places.Autocomplete(input, {
      ...options,
      fields: ["geometry", "place_id", "formatted_address"],
      types: ["establishment"],
    });
    autocomplete.bindTo("bounds", map);

    autocomplete.addListener("place_changed", () => {
      const place = autocomplete.getPlace();
      setIsSelected?.(true);

      // sendEvent(
      //   {
      //     event: EAnalyticsEvent.Custom,
      //     event_action: EAnalyticsEventAction.AddressJourney,
      //     event_category: EAnalyticsEventCategory.UserEngagement,
      //     event_label: EAnalyticsEventLabel.AddressSearchSuggestionsDisplayed,
      //   },
      //   getDefaultAddressAnalyticsParams(
      //     EAnalyticsScreenName.AddDeliveryLocationNoLocationSelected,
      //   ),
      // );

      if (
        !place.geometry ||
        (!place.geometry.viewport && !place.geometry.location)
      ) {
        console.error("No geometry available for the selected place.");
        return;
      }

      const { location } = place.geometry;
      const lat = location?.lat();
      const lng = location?.lng();

      if (lat && lng) {
        setCoordinates?.({ lat: Number(lat), lng: Number(lng) });
        setUpdatedLocation({ lat: Number(lat), lng: Number(lng) });
        setFormattedAddress({ lat: Number(lat), lng: Number(lng) }, true);
        checkAreaSupport(Number(lat), Number(lng));
      }
    });
    setMapInstance(map);
  }
};

export const onMapCenterChanged = ({
  mapInstance,
  setShowPin,
  updatedLocation,
  setCoordinates,
  setUpdatedLocation,
  setFormattedAddress,
  checkAreaSupport,
  // sendEvent,
}: IOnMapCenterChangedProps): void => {
  if (mapInstance) {
    setShowPin(true);
    const centerLat = mapInstance.getCenter()?.lat();
    const centerLng = mapInstance.getCenter()?.lng();

    if (
      centerLat !== updatedLocation.lat ||
      centerLng !== updatedLocation.lng
    ) {
      setCoordinates?.({
        lat: Number(centerLat),
        lng: Number(centerLng),
      });
      setUpdatedLocation({ lat: Number(centerLat), lng: Number(centerLng) });
      setFormattedAddress(
        { lat: Number(centerLat), lng: Number(centerLng) },
        true,
      );
      checkAreaSupport(Number(centerLat), Number(centerLng));
    }
    // sendEvent(
    //   {
    //     event: EAnalyticsEvent.Custom,
    //     event_action: EAnalyticsEventAction.AddressJourney,
    //     event_category: EAnalyticsEventCategory.UserEngagement,
    //     event_label: EAnalyticsEventLabel.AddressPinDropped,
    //   },
    //   getDefaultAddressAnalyticsParams(
    //     EAnalyticsScreenName.AddDeliveryLocationUserSearchesForLocation,
    //   ),
    // );
  }
};
